import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@univacity/shared/types';

@Pipe({
  name: 'address',
  standalone: false,
})
export class AddressPipe implements PipeTransform {
  transform(addr: Address): string {
    const v: string[] = [];
    if (addr.street) v.push(addr.street);
    if (addr.city) v.push(addr.city);
    if (addr.zipcode) v.push(addr.zipcode);
    if (addr.state) v.push(addr.state);
    if (addr.country) v.push(addr.country);
    return v.join(', ');
  }
}
